module.exports = __webpack_public_path__ + "img/help-circle.239fd0ca.svg";